import { Component, Inject, InjectionToken } from '@angular/core';

export const ItemsListHeadItemLabelComponent_headComponent = new InjectionToken(
    'ItemsListHeadItemLabelComponent_headComponent',
);

@Component({
    selector: 'fi-items-list-head-item-label',
    template: '{{headComponent.head.Label}}',
    standalone: false,
})
export class ItemsListHeadItemLabelComponent {
    constructor(@Inject(ItemsListHeadItemLabelComponent_headComponent) public headComponent: any) {}
}
